import en from './en'
import zh from './cn'

export default {
  en,
  zh
}
